import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'glxy-label, [glxyLabel]',
  standalone: false,
})
export class LabelDirective {
  @HostBinding('class') class = 'glxy-label';
}
